export const NotFound = () => {
  return (
    <div className="ninja text-6xl -rotate-[10deg] mx-auto underline pt-8 pb-12 text-center">
      Oups! <br />
      Page not found
    </div>
  );
};
